export default{
    msg:'',
    editar:{},
    lista:'',
    listaevento:'',
    doc:'',
    matricula:'',
}